export const customHeader = () => {
  jQuery('body').addClass('webview-header');  
};
  
export const customFooter = () => {
  jQuery('body').addClass('webview-footer');  
}; 


// WEBPACK FOOTER //
// ./src/_override/shared/app-webview/webview-functions.js